import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { preLoadCheckout } from 'actionCreators/preLoadCheckout';

const AceleratorScript: React.FC<any> = ({ state, dispatch }) => {
  useEffect(() => {
    return () => dispatch(preLoadCheckout());
    // eslint-disable-next-line
  }, [state.preLoadCheckout.done]);

  if (state.preLoadCheckout.done) return null;
  return (
    !state.preLoadCheckout.done && (
      <iframe
        title="CheckoutSun"
        width="0px"
        height="0px"
        style={{ display: 'block' }}
        src="https://sun.eduzz.com/pixel/preload"
      ></iframe>
    )
  );
};

const mapStateToProps = (state: any) => ({
  state
});

export default connect(mapStateToProps)(AceleratorScript);
